import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { pauseColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPause } from "../../../../api/sim";

const COPY_KEYS = ["id", "batch_id", "msisdn", "iccid", "status", "last_updated"];

const TmobilejPauseBatch = () => (
  <BatchDetail
    title="Suspend (Pause)"
    apiGet={__getPause}
    client={CLIENTS.tmobilej}
    columnsFactory={pauseColumns}
    copyKeys={COPY_KEYS}
    exportAction="pause"
    retryOperation="pause"
    showTerminate
    getRowPath={(row) => `/tmobilej/pause/${row.id}`}
  />
);

export default TmobilejPauseBatch;
